var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import { cx, css as emotionCss } from 'emotion';
import { ACTIVATE_BUTTONS as activateButtons } from '../constants';
import { fixedRowListStyles, focusedSelectAllRowStyles, selectAllRowStyles } from '../../../styles/legacy';
import { fixedRowListStyles as fixedRowListStylesCitrus2022, focusedSelectAllRowStyles as focusedSelectAllRowStylesCitrus2022, selectAllRowStyles as selectAllRowStylesCitrus2022, selectAllButtonStyles as selectAllButtonStylesCitrus2022, } from '../../../styles/citron';
import { resetInputValue } from '../utils/inputFunctions';
import { useKeyPress } from '../utils/useKeyPress';
import { SelectAll } from '../../Select.styled';
import { getAutomation, getStyleNames } from '@citrus/runtime';
import { useTheme } from '@citrus/user';
var SelectAllButton = function (_a) {
    var _b, _c;
    var _d, _e, _f, _g;
    var automationId = _a.automationId, isMulti = _a.isMulti, inputValue = _a.inputValue, setInputValue = _a.setInputValue, value = _a.value, filterTyping = _a.filterTyping, handleListKeypress = _a.handleListKeypress, handleOnChange = _a.handleOnChange, setFilterTyping = _a.setFilterTyping, setPersistedInputValue = _a.setPersistedInputValue, selectAllOptionText = _a.selectAllOptionText, deselectAllOptionText = _a.deselectAllOptionText, selectFilteredOptionText = _a.selectFilteredOptionText, deselectFilteredOptionText = _a.deselectFilteredOptionText, listDataArray = _a.listDataArray, searchable = _a.searchable, setListDataArraySwitch = _a.setListDataArraySwitch, textInputRef = _a.textInputRef;
    var _h = useState(false), focusedRow = _h[0], setFocusedRow = _h[1];
    var isCitron = useTheme().citrus2022;
    var optionsWithoutDisabledAndHeaders = listDataArray.filter(function (opt) { return !opt.header && !opt.disabled && !opt.creatable; });
    var filteredOptionNotInValue = optionsWithoutDisabledAndHeaders.filter(function (opt) { return value.findIndex(function (x) { return x.optionsIndex === opt.optionsIndex; }) === -1; });
    var toggleFocus = function (e) {
        if (e.type === 'focus') {
            setFocusedRow(true);
        }
        if (e.type === 'blur') {
            setFocusedRow(false);
        }
    };
    var selectText = function () {
        if (filteredOptionNotInValue.length) {
            return (filterTyping && selectFilteredOptionText) || selectAllOptionText || 'Select All';
        }
        return (filterTyping && deselectFilteredOptionText) || deselectAllOptionText || 'Deselect All';
    };
    // row styles
    var fixedRowListStylesObj = isCitron ? fixedRowListStylesCitrus2022 : fixedRowListStyles;
    var selectAllRowStylesObj = isCitron ? selectAllRowStylesCitrus2022 : selectAllRowStyles;
    var focusedSelectAllRowStylesObj = isCitron ? focusedSelectAllRowStylesCitrus2022 : focusedSelectAllRowStyles;
    var rowHeightStylesObj = {
        height: 50,
        padding: '4px 8px 6px 8px',
    };
    var rowEmotionObj = (_b = {},
        _b[emotionCss(fixedRowListStylesObj)] = true,
        _b[emotionCss(selectAllRowStylesObj)] = true,
        _b[emotionCss(focusedSelectAllRowStylesObj)] = focusedRow,
        _b[emotionCss(rowHeightStylesObj)] = isCitron,
        _b);
    var rowStyles = cx(rowEmotionObj);
    var rowStyleNames = {
        fixedRowListStyles: (_d = rowEmotionObj[emotionCss(fixedRowListStylesObj)]) !== null && _d !== void 0 ? _d : false,
        selectAllRowStyles: (_e = rowEmotionObj[emotionCss(selectAllRowStylesObj)]) !== null && _e !== void 0 ? _e : false,
        focusedSelectAllRowStyles: (_f = rowEmotionObj[emotionCss(focusedSelectAllRowStylesObj)]) !== null && _f !== void 0 ? _f : false,
        rowHeightStyles: (_g = rowEmotionObj[emotionCss(rowHeightStylesObj)]) !== null && _g !== void 0 ? _g : false,
    };
    // button styles
    var selectAllButtonStylesObj = selectAllButtonStylesCitrus2022;
    var buttonEmotionObj = (_c = {},
        _c[emotionCss(selectAllButtonStylesObj)] = true,
        _c);
    var buttonStyles = cx(buttonEmotionObj);
    var buttonStyleNames = {
        selectAllButtonStyles: buttonEmotionObj[emotionCss(selectAllButtonStylesObj)],
    };
    var handleSelectAll = function (e) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var activatePressed = useKeyPress(e, activateButtons);
        var mouseDown = e.type === 'mousedown';
        var touchStart = e.type === 'touchstart';
        if (!activatePressed && !mouseDown && !touchStart)
            return handleListKeypress(e);
        if (!touchStart)
            e.preventDefault();
        e.stopPropagation();
        if (!filterTyping && filteredOptionNotInValue.length) {
            handleOnChange(optionsWithoutDisabledAndHeaders);
        }
        else if (filterTyping && filteredOptionNotInValue.length) {
            handleOnChange(__spreadArray(__spreadArray([], value, true), filteredOptionNotInValue, true));
        }
        else if (!filteredOptionNotInValue.length) {
            var valueWithoutFilteredOptions = value.filter(function (x) { return optionsWithoutDisabledAndHeaders.findIndex(function (opt) { return x.optionsIndex === opt.optionsIndex; }) === -1; });
            var deselectArr = filterTyping ? valueWithoutFilteredOptions : [];
            handleOnChange(deselectArr);
        }
        // refocus input on selection
        if (textInputRef.current) {
            textInputRef.current.focus();
            textInputRef.current.setSelectionRange(0, 0);
        }
        if (searchable) {
            resetInputValue({ inputValue: inputValue, isMulti: isMulti, value: value, setInputValue: setInputValue, setFilterTyping: setFilterTyping, setPersistedInputValue: setPersistedInputValue });
            setPersistedInputValue(inputValue);
            setListDataArraySwitch(true);
        }
        setFilterTyping(false);
    };
    if (isCitron) {
        return (React.createElement("div", { className: rowStyles },
            React.createElement(SelectAll, __assign({}, getAutomation(automationId, 'input-select-select-all'), { className: buttonStyles, onBlur: toggleFocus, onFocus: toggleFocus, onKeyDown: handleSelectAll, onMouseDown: handleSelectAll, onTouchStart: handleSelectAll, styleNames: getStyleNames(buttonStyleNames), tabIndex: 0 }), selectText())));
    }
    return (React.createElement(SelectAll, __assign({}, getAutomation(automationId, 'input-select-select-all'), { className: rowStyles, onBlur: toggleFocus, onFocus: toggleFocus, onKeyDown: handleSelectAll, onMouseDown: handleSelectAll, onTouchStart: handleSelectAll, styleNames: getStyleNames(rowStyleNames), tabIndex: 0 }), selectText()));
};
export default SelectAllButton;
